module.exports = __webpack_public_path__ + "img/Faux-Fur_fr.ba08c756.jpg";